var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0959 7.60027C10.1623 7.76633 10.3233 7.87566 10.5021 7.87566H12.7111C11.6367 9.4863 9.82058 11.2633 7.00214 13.1257C4.18358 11.2633 2.36658 9.48635 1.29218 7.87566H3.50214C3.64826 7.87554 3.78434 7.80192 3.86542 7.68035L5.15448 5.74773L6.59589 9.35027C6.66539 9.52393 6.83779 9.63424 7.0246 9.62468C7.21112 9.61494 7.37061 9.48783 7.42206 9.30828L8.8205 4.41375L10.0959 7.60027ZM7.15546 1.00066C10.1429 -1.7491 16.1249 1.47098 13.2326 7.00066H10.798L9.15839 2.90007C9.08892 2.72651 8.91638 2.61622 8.72968 2.62566C8.54284 2.63522 8.38264 2.76316 8.33124 2.94304L6.93281 7.83757L5.65839 4.65007C5.59803 4.49928 5.45862 4.39444 5.29706 4.37761C5.13554 4.36081 4.97802 4.43493 4.88788 4.57L3.26777 7.00066H0.770695C-2.12161 1.47102 3.86042 -1.74901 6.84784 1.00066C6.90002 1.04869 6.95186 1.09839 7.00214 1.15008C7.05234 1.09848 7.10338 1.0486 7.15546 1.00066Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.8bd615abcebc09b7c682f3647ee9a904.svg";
export { ForwardRef as ReactComponent };